// extracted by mini-css-extract-plugin
export default {"root":"StatusChecklistItem_root__pMmZO","selected":"StatusChecklistItem_selected__+kA79"};